import React, { Component } from 'react';
import utilFunction from '../../containers/function';
import strings from '../locales/';
import BarChart from '../common/graphs/crossfilterGraphs/barChart';

const WaitingTimesHistogramGraph = props => (
  <div id="waiting-times-histogram-graph" className="dc-chart-parent">
    <BarChart
      id={'waiting-times-histogram-graph-component'}
      additionalCrossfilterData={null}
      crossfilerData={utilFunction.generateCrossfilter(props.data)}
      stack={false}
      dimension={{
        formatFunction: [],
        name: 'label',
        originalName: 'label',
        reduceFunction: {
          type: 'DISCRETE_GROUP',
          typeof: 'STRING',
          parameters: {
            categoriesParser: [],
            categories: [
              [{ value: '0-30', operator: '==' }],
              [{ value: '30-60', operator: '==' }],
              [{ value: '60-90', operator: '==' }],
              [{ value: '90-120', operator: '==' }],
              [{ value: '120-150', operator: '==' }],
              [{ value: '150-180', operator: '==' }],
              [{ value: '180-210', operator: '==' }],
              [{ value: '210-240', operator: '==' }],
              [{ value: '240-270', operator: '==' }],
              [{ value: '270-300', operator: '==' }],
              [{ value: '300+', operator: '==' }]
            ],
            labels: [
              '0-30',
              '30-60',
              '60-90',
              '90-120',
              '120-150',
              '150-180',
              '180-210',
              '210-240',
              '240-270',
              '270-300',
              '300+'
            ]
          }
        }
      }}
      metrics={[
        {
          config: {},
          filter: [],
          formatFunction: [],
          metric: 'count',
          name: 'count',
          reduceFunction: { type: 'AVG' },
          type: 'AVG'
        }
      ]}
      config={{
        horizontal: false,
        tooltip: {
          valuesConfig: [
            {
              identifier: 'x',
              valueFormat: { type: 'STRING', format: '' },
              wrapper: `<div>${props.tooltip.plantTime} <span style='font-weight: bold;'>%v ${
                props.tooltip.minutes
              }</span></div>`
            },
            {
              identifier: 'y',
              valueFormat: { type: 'NUMBER', format: 'd' },
              wrapper: `<div><span style='font-weight:bold;'>%v</span> ${
                props.tooltip.ocasion
              }</div>`
            }
          ]
        },
        gap: 80,
        colors: ['#5192DC'],
        xAxis: { labelPadding: 36, rotation: -25, label: 'Duración (minutos)' },
        yAxis: { show: true, ticksNumber: 3, format: '.0f' }
      }}
      dashboardId={'detail_waiting_times'}
    />
  </div>
);

export default WaitingTimesHistogramGraph;



// WEBPACK FOOTER //
// ./source/client/components/detail_waiting_times/waitingTimesHistogramGraph.jsx